import React, { FC, useState } from "react";
import { Article } from "data/types";
import Link from "components/Link";
import Layout from "app/(others)/layout";


export interface CardProps {
  className?: string;
  post: Article;
}

const Card: FC<CardProps> = ({ className = "h-full", post }) => {
  const { href, date, titre, image, description, html } = post;
  const [isHover, setIsHover] = useState(false);

  return (
    <a href={href} >
    <Layout>
     
        <div
        className={`nc-Card10V2 relative flex flex-col ${className}`}
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        >
            <h2 className="articleTitre">{titre}</h2>
            {date}
            <div className="block group rounded-3xl flex-shrink-0 relative w-full aspect-w-16 aspect-h-12 sm:aspect-h-9 overflow-hidden z-0">
                <Link href={href} className="absolute inset-0" >
                    <img className="w-full h-full object-cover" src={image}/>    
                </Link>
            </div>
            <div className="articleDescription" >
                {description}
            </div>
        </div>
   
    </Layout>
    </a>
  );
};

export default Card;
